let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hu6xO")).then(() => parcelRequire('dPHT6'));